<!-- ----------------------------------------------- -->
<template>
  <v-col
    class="tm-mb-frame-content tm-mb-cctv-card"
    v-if="tmCctvList.length !== 0"
  >
    <tm-cctv-info></tm-cctv-info>
    <v-card class="tm-mb-no-shadow">
      <v-card v-if="showDialog" class="vc-dialog-content px-4 mt-0">
        <v-card class="vc-dialog-card">
          <div class="vc-dialog-header pl-4">
            <span class="vc-dialog-title">履歴動画再生不可</span>
          </div>
          <div class="vc-dialog-box vc-dialog-box-confirm px-4">
            過去画像が不足しているため、表示できません。
          </div>
          <div class="vc-dialog-box pb-4 pr-4">
            <v-spacer></v-spacer>
            <v-btn outlined small color="success" class="mt-0 ml-4" @click="closeDialog()">
              <v-icon left>clear</v-icon>
              閉じる
            </v-btn>
          </div>
        </v-card>
      </v-card>
      <div class="com-mb-card tm-mb-datail-card pb-2 mb-1">
        <div class="com-mb-card-contents pt-1">
          <div class="tm-mb-detail-tab-btn">
            <v-row no-gutters class="d-flex align-center">
              <template v-if="hasLatestUrl">
                <v-btn
                  v-if="isCurrent"
                  class="tm-mb-btn-live"
                  small
                  :class="{ 'btn-on': selectCamera === 'live' }"
                  @click="selectCamera = 'live'"
                  depressed
                  >{{ text.live.label }}</v-btn
                >
                <v-btn
                  v-if="!isCurrent"
                  class="tm-mb-btn-live"
                  small
                  :class="{ 'btn-on': selectCamera === 'live' }"
                  @click="selectCamera = 'live'"
                  depressed
                  >{{ text.history.label }}</v-btn
                >
              </template>
              <v-btn
                v-if="hasUsualUrl"
                class="tm-mb-btn-normal"
                small
                :class="{ 'btn-on': selectCamera === 'normal' }"
                @click="selectCamera = 'normal'"
                depressed
                >{{ text.normal.label }}</v-btn
              >
              <span class="sns-style ml-auto">
                <tm-sns v-if="!isReduction"></tm-sns>
              </span>
            </v-row>
          </div>
          <div>
            <tm-cctv-dlg
              v-if="modalDiagCctv"
              @close="closeModalCctv"
            ></tm-cctv-dlg>
            <v-touch v-on:doubletap="openModalCctv">
              <!-- 観測設定時 -->
              <div
                v-if="
                  selectCamera === 'live' &&
                  tmCctvList.cctvInfo.latestUrl !== null
                "
                class="tm-mb-rv-cam-title px-2"
              >
                <div v-if="!historyImageMovieFlg">
                  <v-img
                    v-if="isCurrent"
                    :src="printCurrentPicture"
                    class="tm-mb-rv-cam-now-img"
                    :alt="text.live.alt"
                    @error="liveImgError = true"
                  >
                    <template v-slot:placeholder>
                      <v-sheet class="tm-mb-progress-content">
                        <v-progress-circular
                          v-slot:placeholder
                          v-if="!liveImgError"
                          indeterminate
                          class="tm-mb-progress-img"
                        ></v-progress-circular>
                      </v-sheet>
                    </template>
                  </v-img>
                  <v-img
                    v-else
                    :src="printHistoryPicture"
                    class="tm-mb-rv-cam-now-img"
                    :alt="text.history.alt"
                  >
                    <template v-slot:placeholder>
                      <v-sheet class="tm-mb-progress-content">
                        <v-progress-circular
                          v-slot:placeholder
                          v-if="!liveImgError"
                          indeterminate
                          class="tm-mb-progress-img"
                        ></v-progress-circular>
                      </v-sheet>
                    </template>
                  </v-img>
                </div>
                <div v-else-if="historyImageMovieFlg">
                  <v-sheet v-if="imageLoading" class="tm-pc-progress-content">
                    <v-progress-circular
                      indeterminate
                      class="progress-img"
                    ></v-progress-circular>
                  </v-sheet>
                  <img
                    v-else
                    :src="sliderImages[currentIndex]"
                    loading="eager"
                    :alt="isCurrent ? text.live.alt : text.history.alt"
                    @error="liveImgError = true"
                    class="tm-mb-rv-cam-now-img"
                  />
                </div>
              </div>
              <!-- 平常時 -->
              <div
                v-if="
                  selectCamera === 'normal' &&
                  tmCctvList.cctvInfo.usualUrl !== null
                "
                class="tm-mb-rv-cam-title px-2"
              >
                <v-img
                  :src="printNormallyPicture"
                  class="tm-mb-rv-cam-nomal-img"
                  :alt="text.normal.alt"
                  @error="normalImgError = true"
                >
                  <template v-slot:placeholder>
                    <v-sheet class="tm-mb-progress-content">
                      <v-progress-circular
                        v-slot:placeholder
                        v-if="!normalImgError"
                        indeterminate
                        class="tm-mb-progress-img"
                      ></v-progress-circular>
                    </v-sheet>
                  </template>
                </v-img>
              </div>
            </v-touch>
          </div>
        </div>
        <!-- <v-btn
          class="btn-yt-mb ml-auto"
          text
          rounded
          v-if="!modalDiagCctv && tmCctvList.cctvInfo.liveUrl"
          @click="openLiveUrl(tmCctvList.cctvInfo.liveUrl)"
        >
          <span class="btn-yt-mb-text">LIVE配信はこちら</span>
          <img
            id="sns-yt-logo"
            src="/kawabou/img/sns_icons/yt_logo_rgb_light.png"
          />
        </v-btn> -->
      </div>
      <!-- slider -->
      <template v-if="!isReduction && hasLatestUrl && selectCamera === 'live'">
        <template class="com-mb-card-contents">
          <v-row justify="center" class="no-gutters pt-3">
            <v-btn
              v-show="isNotPlayMb"
              rounded
              depressed
              outlined
              color="success"
              @click="readyHistoryImages()"
              :disabled="sliderMissingImages"
            >
              <v-icon left color="success">play_arrow</v-icon>
              <span>{{ text.play }}</span>
            </v-btn>
            <v-btn
              v-show="isReadyMb"
              rounded
              depressed
              outlined
              loading
              color="success"
            >
              <v-icon left color="success">play_arrow</v-icon>
              <span>{{ text.play }}</span>
            </v-btn>
            <v-btn
              v-show="isPlayMb"
              rounded
              depressed
              outlined
              color="success"
              @click="stopPlay()"
            >
              <v-icon left color="red">pause</v-icon>
              <span class="red--text">{{ text.stop }}</span>
            </v-btn>
          </v-row>
          <v-row justify="center" class="no-gutters pl-4 pr-4">
            <v-slider
              v-model="currentIndex"
              @input="handleSlideChange"
              tick-size="0"
              :thumb-color="sliderThumbColor"
              :tick-labels="sliderLabelTime"
              :max="arrayHistoryImages.length === 0 ? 1 :arrayHistoryImages.length - 1"
              min="0"
              step="1"
              :disabled="isSliderDisable"
            >
              <template v-slot:prepend>
                <v-icon
                  :color="isSliderDisable ? 'disable' : 'success'"
                  @click="fastRewind('arrow')"
                  >fast_rewind</v-icon
                >
              </template>
              <template v-slot:append>
                <v-icon
                  :color="isSliderDisable ? 'disable' : 'success'"
                  @click="fastForward('arrow')"
                  >fast_forward</v-icon
                >
              </template>
            </v-slider>
          </v-row>
        </template>
        <v-col>{{ text.tmCctvSliderNote }}</v-col>
      </template>
    </v-card>
  </v-col>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [MB]河川カメラ フレーム
 * TmCctvFrame.vue
 * @author ILUKE
 */
import mixin from "./../../lib/mixin.js";
import Util from "./../../lib/util";
import tmObs from "./../../lib/tmObs.js";
import TmCctvInfo from "./TmCctvInfo.vue";
import TmCctvDlg from "./TmCctvDlg.vue";
import TmSns from "./TmSns.vue";
import PageLog from "./../../lib/pageLog.js";

export default {
  name: "tm-cctv-frame",
  mixins: [mixin],
  components: {
    TmCctvInfo,
    TmCctvDlg,
    TmSns,
  },
  data() {
    return {
      /** 画像取得エラー */
      liveImgError: false,
      normalImgError: false,
      printHistoryPicture: "",
      /** スライダー関連 */
      showDialog: false,
      sliderImages: [],
      imageLoading: true,
      intervalId: null,
      intervalTime: 1000,
      /** 文字列リソース */
      text: {
        title_detail: "観測詳細",
        // 現在(LIVE)
        live: {
          label: "現在",
          alt: "",
        },
        // 過去
        history: {
          label: "過去",
          alt: "",
        },
        // 平常時
        normal: {
          label: "平常時",
          alt: "",
        },
        // 過去画像動画関連
        play: "再生",
        stop: "停止",
        tmCctvSliderNote: "上の再生ボタンを押すと、直前の１~２時間のカメラ画像をコマ送り表示できます。表示間隔は１０分ですが、過去画像がない場合はその時刻をスキップします。"
      },
      modalDiagCctv: false,
    };
  },
  created() {
    this.$log.debug("[TmCctvFrame] created()");
    this.loadTmObs();
  },
  mounted() {
    this.$log.debug("[TmCctvFrame] mounted()");
    this.getPostCamera();
    if (this.isCurrent) {
      this.$store.commit("sns/setPrintCurrentPicture", this.printCurrentPicture);
    }
    this.$store.commit("sns/setPrintNormallyPicture", this.printNormallyPicture);
  },
  beforeDestroy() {
    this.$log.debug("[TmCctvFrame] beforeDestroy()");
    // アクセスログ用パラメータ破棄
    this.$store.commit("Telemeter/setPageLogParam", null);
    // intervalIdのクリア
    clearInterval(this.intervalId);
    this.intervalId = null;
    this.$store.commit("Telemeter/setMovieEndTime", this.setTime);
    if (this.$store.state.Telemeter.historyPrintCurrentPicture.indexOf("/cam/history/") !== -1 || this.$store.state.Telemeter.historyPrintCurrentPicture.indexOf("no-image") !== -1) {
      this.$store.commit("app/setTime", this.setTime);
    } else {
      this.$store.commit("app/renewTime");  
    }
    this.$store.commit("Telemeter/resetHistoryPlay");
    this.$store.commit("Telemeter/resetHistoryPrintCurrentPicture");
  },
  computed: {
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return this.$store.state.Telemeter.selectedTmParam;
      },
    },
    /**
     * カメラ情報 取得
     */
    tmCctvList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /*
     * 提供URLで指定された画像を表示する
     * エラーが発生する場合は、画像URLで指定された画像を表示する
     */
    printCurrentPicture: {
      get() {
        /* コンソールエラー対策 */
        let currentPicture = "";
        if (this.tmCctvList.length !== 0) {
          currentPicture = this.liveImgError ? this.tmCctvList.cctvInfo.subLatestUrl : this.tmCctvList.cctvInfo.latestUrl;
          this.$store.commit("sns/setPrintCurrentPicture", currentPicture);
        }
        return currentPicture;
      },
    },
    printNormallyPicture: {
      get() {
        let normallyPicture = "";
        if (this.tmCctvList.length !== 0) {
          normallyPicture = this.normalImgError ? this.tmCctvList.cctvInfo.subUsualUrl : this.tmCctvList.cctvInfo.usualUrl;
          this.$store.commit("sns/setPrintNormallyPicture", normallyPicture);
        }
        return normallyPicture;
      },
    },
    /** 選択中河川カメラ画像 取得 */
    selectCamera: {
      get() {
        return this.$store.state.Telemeter.selectCamera;
      },
      set(val) {
        this.$store.commit("Telemeter/setSelectCamera", val);
      },
    },
    hasLatestUrl: {
      get() {
        return tmObs.hasLatestUrl(this.tmCctvList.cctvInfo);
      },
    },
    hasUsualUrl: {
      get() {
        return tmObs.hasUsualUrl(this.tmCctvList.cctvInfo);
      },
    },
    /** 簡易版判定 */
    isReduction: {
      get() {
        return global.KWB_MODE == "reduction";
      },
    },
    /** 対象日時 */
    appTime: {
      get() {
        return this.$store.state.app.appTime;
      },
    },
    /**観測日時更新フラグ */
    isCurrent: {
      get() {
        return this.$store.state.app.isCurrent;
      },
    },
     /* 過去画像 */
    historyPrintCurrentPicture: {
      get() {
        return this.$store.state.Telemeter.historyPrintCurrentPicture;
      },
    },
    /** 再生状態 */
    playStatus: {
      get() {
        return this.$store.getters["Telemeter/historyPlayStatus"];
      },
      set(val) {
        this.$store.commit("Telemeter/setHistoryPlayStatus", val);
      },
    },
    /** 履歴再生中状態 */
    isPlayMb: {
      get() {
        return this.$store.getters["Telemeter/isPlayMb"];
      },
    },
    /** 履歴停止中以外状態 */
    isReadyMb: {
      get() {
        return this.$store.getters["Telemeter/isReadyMb"];
      },
    },
    /** 履歴停止中状態 */
    isStopMb: {
      get() {
        return this.$store.getters["Telemeter/isStopMb"];
      },
    },
    /** 履歴動画再生/準備中以外状態 */
    isNotPlayMb: {
      get() {
        return this.$store.getters["Telemeter/isNotPlayMb"];
      },
    },
    /** 履歴動画未再生状態 */
    isNoneMb: {
      get() {
        return this.$store.getters["Telemeter/isNoneMb"];
      },
    },
    /* 過去画像が格納された配列 */
    arrayHistoryImages() {
      return this.$store.getters["Telemeter/arrayHistoryImages"];
    },
    /* 取得した画像と同じ時間の配列(appTime用) */
    arrayHistoryAppTime() {
      return this.$store.state.Telemeter.historyImageSlider.arrayHistoryAppTime;
    },
    /* 取得した画像と同じ時間の配列(スライダーラベル用) */
    sliderLabelTime() {
      return this.$store.state.Telemeter.historyImageSlider.sliderLabelTime;
    },
    /* スライダー有効判定 */
    isSliderDisable: {
      get() {
        return this.isDisable || this.isReadyMb || this.isNoneMb;
      },
    },
    /* スライダー色 */
    sliderThumbColor: {
      get() {
        let color = "success";
        if (this.isPlayMb) {
          color = "red";
        }
        if (this.isSliderDisable) {
          color = "disable";
        }
        return color;
      },
    },
    /* appTime制御フラグ */
    appTimeControlFlg: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.appTimeControlFlg;
      },
      set(val) {
        this.$store.commit("Telemeter/setAppTimeControlFlg", val);
      },
    },
    /* 過去画像不足フラグ */
    sliderMissingImages: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.sliderMissingImages;
      },
      set(val) {
        this.$store.commit("Telemeter/setSliderMissingImages", val);
      },
    },
    /* 過去画像再生ボタン押下フラグ */
    historyImageMovieFlg: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.historyImageMovieFlg;
      },
      set(val) {
        this.$store.commit("Telemeter/setHistoryImageMovieFlg", val);
      },
    },
    /* スライダーの現在位置 */
    currentIndex: {
      get() {
        return this.$store.getters["Telemeter/movieCurrentIndex"];
      },
      set(valIndex) {
        this.$store.commit("Telemeter/setMovieCurrentIndex", valIndex);
      },
    },
    isEnlarged() {
      return this.$store.state.Telemeter.historyImageSlider.isEnlargeView;
    },
    setTime: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.movieEndTime;
      },
    },
    camSlidData: {
      get() {
        return this.$store.state.app.config.tmObsConfig.cctv;
      },
    },
    originProduction: {
      get() {
        return this.$store.state.app.config.originProduction;
      },
    },
    historyCamUrl: {
      get() {
        return this.$store.state.app.config.tmObsConfig.historyCamUrl;
      },
    },
    testEnvironmentsIp: {
      get() {
        return this.$store.state.app.config.testEnvironmentsIp;
      },
    },
    /* アクセスログ出力用パラメータ */
    pageLogParam: {
      get() {
        if (
          this.$store.state.Telemeter.pageLogParam &&
          this.$store.state.Telemeter.pageLogParam.obsData
        ) {
          return {
            prefCd:
              this.$store.state.Telemeter.pageLogParam.obsData.obsInfo.prefCd,
            twnCd:
              this.$store.state.Telemeter.pageLogParam.obsData.obsInfo.twnCd,
            rvrCd:
              this.$store.state.Telemeter.pageLogParam.obsData.obsInfo.rvrCd,
            camCd: this.$store.state.Telemeter.pageLogParam.payload.scamId,
            camSb: "cctv",
          };
        }
        return null;
      },
    }
  },
  methods: {
    openModalCctv() {
      this.$store.commit('Telemeter/setEnlargedView', true);
      this.modalDiagCctv = true;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.$store.commit('Telemeter/setEnlargedMovieCurrentIndex',this.currentIndex);
      this.$store.commit("Telemeter/syncStatus");
    },
    closeModalCctv() {
      this.$store.commit('Telemeter/setEnlargedView', false);
      this.modalDiagCctv = false;
      // 拡大画面にて画像不足でダイアログ表示済みの場合、通常画面ではダイアログ非表示にするため
      if (this.sliderMissingImages) {
        this.showDialog = false;
      } else if (this.historyImageMovieFlg) {
        this.changeToNormalSetImages();
      }
    },
    /**
     * 画面更新処理
     */
    loadTmObs() {
      // 選択中テレメータ情報クリア
      this.$store.commit("Telemeter/setSelectedTm", []);
      // お知らせ・河川予警報ダイアログ非表示
      this.$store.commit("map/hideInfoRw");

      // カメラ情報を取得
      setTimeout(() => {
        this.$store
          .dispatch("Telemeter/getSelectedTm", {
            ofcCd: this.reqParam.ofcCd,
            itmkndCd: this.reqParam.itmkndCd,
            cctvCd: this.reqParam.cctvCd,
            ownCd: this.reqParam.ownCd,
            scamId: this.reqParam.scamId,
            sysCamId: this.reqParam.sysCamId,
            sysId: this.reqParam.sysId,
          })
          .then(() => {
            /** 
             * カメラ画像表示
             * @property {boolean} this.isCurrent 観測日時 現在/過去フラグ
             * @property {string} this.$store.state.Telemeter.historyPrintCurrentPicture 過去画像の有無 
             * @property {boolean} this.historyImageMovieFlg 履歴動画再生フラグ
             */
            if (!this.isCurrent && !this.historyImageMovieFlg && !this.$store.state.Telemeter.historyPrintCurrentPicture) {
              this.getAllHistoryData();
            } else if (!this.isCurrent && !this.historyImageMovieFlg && this.$store.state.Telemeter.historyPrintCurrentPicture) {
              this.printHistoryPicture = this.historyPrintCurrentPicture;
            } else if (this.historyImageMovieFlg) {
              this.currentIndex = this.$store.getters["Telemeter/movieCurrentIndex"];
              this.changeToNormalSetImages();
            }
            // 取得後リフレッシュする
            this.refreshImage();
          });
      }, 500);
    },
    // URLパラメータチェック
    checkUrlParam(to, from) {
      if (
        from.query.fld !== to.query.fld ||
        from.query.ofcCd !== to.query.ofcCd ||
        from.query.itmkndCd !== to.query.itmkndCd ||
        from.query.cctvCd !== to.query.cctvCd ||
        from.query.ownCd !== to.query.ownCd ||
        from.query.sysCamId !== to.query.sysCamId ||
        from.query.scamId !== to.query.scamId ||
        from.query.sysId !== to.query.sysId
      ) {
        return true;
      }
      return false;
    },
    getPostCamera() {
      this.$log.debug("[TmCctvFrame] getPostCamera()");
      this.$store.dispatch("sns/getPostCamera", { camera: this.selectCamera });
    },
    refreshImage() {
      if (this.hasLatestUrl) {
        URL.revokeObjectURL(this.printCurrentPicture);
      }
      if (this.hasUsualUrl) {
        URL.revokeObjectURL(this.printNormallyPicture);
      }
    },
    getSelectedObsData() {
      const appTime = this.isCurrent ? new Date(this.$store.state.Telemeter.historyImageSlider.movieEndTime) : new Date(this.appTime);
      const currProvUrl = this.printCurrentPicture;
      const cameraId = tmObs.extractImageName(currProvUrl);
      const itmkndCd = this.$store.state.Telemeter.selectedTmParam.itmkndCd;
      // カメラ種別 (過去画像取得時間簡易カメラ5分、河川カメラ10分出し分け用)
      const sysId = this.$store.state.Telemeter.selectedTm.cctvInfo.sysId;

      return {
        appTime: appTime,
        cameraId: cameraId,
        itmkndCd: itmkndCd,
        sysId: sysId,
      }
    },
    /** 過去観測時間指定時、過去画像と詳細時間があれば取得し、表示 */
    async getAllHistoryData() {
      const historyImageUrl = await tmObs.obsAppTimeArray(this.getSelectedObsData(), this.originProduction, this.historyCamUrl, this.testEnvironmentsIp);
      this.updatePrintCurrentPicture(historyImageUrl);
      this.$store.commit("Telemeter/setMovieEndTime", Util.formatDate(this.appTime));
    },
    updatePrintCurrentPicture(historyImageUrl) {
      this.printHistoryPicture = historyImageUrl;
      this.$store.commit("Telemeter/setHistoryPrintCurrentPicture", this.printHistoryPicture);
      this.$store.commit("sns/setPrintCurrentPicture", this.printHistoryPicture);
    },
    readyHistoryImages() {
      this.$log.debug("[TmCctvFrame] readyHistoryImages()");
      // アクセスログ出力
      PageLog.log({
        page_log: "cctv_movie",
        zm: this.$store.state.map.zoom,
        cam_cd: this.$store.state.Telemeter.selectedTmParam.scamId,
        cam_sb: "cctv",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });

      // 停止または再再生時
      if (this.isPlayMb) {
        this.playStatus = "stop";
        return;
      } else if (this.isStopMb) {
        this.playStatus = "play";
        return;
      }
      
      this.addCurrentTmQueryTime();
      // 初回再生
      this.playStatus = "readyMovie";
      this.$store.dispatch("Telemeter/obsAppTimeArray", [this.getSelectedObsData(), this.camSlidData, this.originProduction, this.historyCamUrl, this.testEnvironmentsIp]);
    },
    addCurrentTmQueryTime() {
      if (this.isCurrent) {
        this.$store.commit("Telemeter/setMovieEndTime", tmObs.getBaseTime(this.appTime, this.isCurrent, this.$store.state.radar.radarType, this.$store.state.radar.radarXrainDate, this.$store.state.radar.radarCbandDate));
        this.replaceTmQuery("currentTime");
      }
    },
    fastForward(type) {
      this.$log.debug("[TmCctvFrame] fastForward()");
      if (this.currentIndex < this.arrayHistoryImages.length - 1) {
        this.currentIndex++;
        if (this.isPlayMb || this.isStopMb) {
          this.$store.commit("sns/setPrintCurrentPicture", this.sliderImages[this.currentIndex]);
          if (type === 'arrow') {
            this.$store.commit("Telemeter/setAppTimeControlFlg", true);
            this.$store.commit("app/setTime", this.arrayHistoryAppTime[this.currentIndex]);
          } else {
            this.$store.commit("app/setTime", this.arrayHistoryAppTime[this.currentIndex]);
          }
        }
      } else {
        this.stopPlay();
      }
    },
    fastRewind(type) {
      this.$log.debug("[TmCctvFrame] fastRewind()");
      if (this.currentIndex > 0) {
        this.currentIndex--;
        if (this.isPlayMb || this.isStopMb) {
          this.$store.commit("sns/setPrintCurrentPicture", this.sliderImages[this.currentIndex]);
          if (type === 'arrow') {
            this.$store.commit("Telemeter/setAppTimeControlFlg", true);
            this.$store.commit("app/setTime", this.arrayHistoryAppTime[this.currentIndex]);
          } else {
            this.$store.commit("app/setTime", this.arrayHistoryAppTime[this.currentIndex]);
          }
        }
      } else {
        this.currentIndex = 0;
      }
    },
    handleSlideChange(index) {
      this.$log.debug("[TmCctvFrame] handleSlideChange()");
      // 画面表示時、@inputが意図せず、-1を返してしまうため早期リターン
      if (index === -1) {
        return
      }
      this.appTimeControlFlg = false;
      this.currentIndex = index;
      if (this.isPlayMb || this.isStopMb) {
        this.$store.commit("sns/setPrintCurrentPicture", this.sliderImages[this.currentIndex]);
        if (!this.appTimeControlFlg) {
          this.$store.commit("Telemeter/setAppTimeControlFlg", true);
          this.$store.commit("app/setTime", this.arrayHistoryAppTime[this.currentIndex]);
        }
      }
    },
    /** 再生 */
    startAutoPlay() {
      this.$log.debug("[TmCctvFrame] startAutoPlay()");
      this.historyImageMovieFlg = true;
      this.playStatus = "play";
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        this.fastForward();
      }, this.intervalTime);
    },
    /** 停止 */
    stopPlay() {
      this.$log.debug("[TmCctvFrame] stopPlay()");
      this.playStatus = "stop";
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    resetLocalIndex() {
      this.currentIndex = 0;
      this.$store.commit("app/setTime", this.arrayHistoryAppTime[0]);
      this.startAutoPlay();
    },
    setHistoryImages() {
      this.sliderImages = this.arrayHistoryImages;
      this.imageLoading = false;
      if (!this.historyImageMovieFlg) {
        this.$store.commit("Telemeter/setHistoryImageMovieFlg", true);
        this.playStatus =  "play";
        return;
      } else if (this.isPlayMb) {
        this.playStatus =  "stop";
        return;
      } else if (this.isStopMb) {
        this.playStatus =  "play";
      }
    },
    /** 拡大画面から通常画面切り替え時画像セット */
    changeToNormalSetImages() {
      this.sliderImages = this.arrayHistoryImages;
      this.imageLoading = false;
      if (this.isPlayMb) {
        this.startAutoPlay();
      } else if (this.isStopMb) {
        this.stopPlay();
      }
    },
    closeDialog() {
      this.showDialog = false;
      this.sliderMissingImages = true;
      this.historyImageMovieFlg = false;
    },
    openLiveUrl(url) {
      // アクセスログ出力
      PageLog.log({
        page_log: "mob_sns",
        obs_cd: "-",
        cam_cd: this.$store.state.Telemeter.selectedTmParam.scamId,
        cam_sb: "cctv",
        device_sb: this.$store.state.app.mode,
        sns: "yt",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });

      this.$log.debug("[TmCctvFrame] openLiveUrl(" + url + ")");
      var win = window.open("", "_blank");
      if (url != null) {
        win.location.href = url;
      }
    }
  },
  watch: {
    // 観測所遷移 監視
    $route(to, from) {
      if (this.checkUrlParam(to, from)) {
        this.loadTmObs();
      }
    },
    selectCamera() {
      this.$log.debug("[rp]watch - getPostCamera()");
      this.getPostCamera();
      if (this.historyImageMovieFlg && this.isPlayMb && this.selectCamera === 'normal') {
        this.stopPlay();
      }
    },
    // カメラ情報取得 監視
    tmCctvList() {
      this.$log.debug("[TmCctvFrame]watch - tmScamList");
      if (this.hasLatestUrl) {
        this.selectCamera = "live";
      } else {
        this.selectCamera = "normal";
      }
      if (this.tmCctvList && this.tmCctvList.cctvInfo) {
        // コンソールエラー対策
        if (this.isCurrent) {
          this.$store.commit("sns/setPrintCurrentPicture", this.printCurrentPicture);
        }
        this.$store.commit("sns/setPrintNormallyPicture", this.printNormallyPicture);
      }
    },
    appTime() {
      this.$log.debug("[TmCctvFrame]watch - appTime");
      // 選択中観測所 過去画像動画再生処理中による観測日時更新時は画面更新させない
      if (this.isPlayMb || this.appTimeControlFlg || this.isEnlarged) {
        this.$store.commit("Telemeter/setAppTimeControlFlg", false);
      } else {
        this.loadTmObs();
        // 過去画像動画状態をリセット
        this.$store.commit("Telemeter/resetHistoryPlay");
        this.$store.commit("Telemeter/resetHistoryPrintCurrentPicture");
      }
    },
    arrayHistoryImages(array) {
      this.$log.debug("[TmCctvFrame]watch - arrayHistoryImages");
      if (this.isEnlarged) {
        return;
      }

      if (this.isReadyMb && array.length >= 4) {
        this.setHistoryImages();
        this.$store.commit("sns/setPrintCurrentPicture", this.arrayHistoryImages[0]);
      }
    },
    playStatus(status) {
      this.$log.debug("[TmCctvFrame]watch - playStatus");
      if (!this.historyImageMovieFlg && !this.sliderImages.length || this.isEnlarged) {
        return;
      }
      
      if (this.historyImageMovieFlg && this.currentIndex === this.arrayHistoryImages.length -1 && status === "play") {
        this.resetLocalIndex();
      } else if (0 < this.currentIndex < this.arrayHistoryImages.length -1 && status === "play") {
        this.$store.commit("app/setTime", this.arrayHistoryAppTime[this.currentIndex]);
        this.startAutoPlay();
      } else if (status === "stop") {
        this.stopPlay();
      }
    },
    sliderMissingImages(flg) {
      this.$log.debug("[TmCctvFrame]watch - sliderMissingImages");
      if (flg) {
        this.showDialog = true;
        this.currentIndex = 0;
        this.playStatus = "none";
        this.replaceTmQuery();
      }
    },
    /* アクセスログ出力用パラメータ */
    pageLogParam(to, from) {
      if (to && (!from || to.camCd != from.camCd)) {
        // アクセスログ出力
        PageLog.log({
          page_log: "cctv",
          pref_cd: to.prefCd,
          twn_cd: to.twnCd,
          rvr_cd: to.rvrCd,
          cam_cd: to.camCd,
          cam_sb: to.camSb,
          device_sb: this.$store.state.app.mode,
          fc_flg: this.$store.getters["app/isFldCtl"],
        });
      }
    }
  }
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/color.scss";

.sns-style {
  width: 110px !important;
}

.tm-mb-cctv-card {
  position: relative;
}

.vc-dialog-content {
  position: absolute;
  background-color: rgba(lightgray, 0.8);
  // opacity: 0.8;
  z-index: 3030;
  width: 100%;
  height: 100%;

  .vc-dialog-card {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .vc-header {
      display: flex;
    }
    .vc-dialog-header {
      background-color: $color-header-back;
      color: $color-header-text;
      line-height: 40px;
      height: 40px;
      width: 100%;
    }
    .vc-dialog-box {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      width: 100%;
      .vc-dialog-box-confirm {
        font-size: 1rem;
      }
    }
  }
}
</style>
